import merge from 'lodash.merge'

export default {
  props: {
    trans: {
      type: Object,
      default() { return {} }
    }
  },

  data() {
    return {
      i18n: merge({}, window.trans, this.trans),
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/shared/mixins/translatable.js